import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import logo from "../logo.svg";
import "./Nav.css";
import "./Login.css";

function Login({ login }) {
  return (
    <>
      <Container className="nav-content">
        <img src={logo} alt="Switch2 Logo" className="nav-logo" />
      </Container>
      <Container className="coreContent">
        <Row className="mb-4">
          <Col>
            <div className="info-message">
              Please login to access the system.
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button onClick={login}>Login</Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

export default Login;
